<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  ><g
    stroke="currentColor"
    stroke-width="1.75"
    clip-path="url(#a)"
  ><path
    stroke-linecap="round"
    stroke-linejoin="round"
    d="M5.612 7.198a8.53 8.53 0 0 1 7.083-3.616c.703.002 1.404.09 2.086.26l1.854-2.105a.686.686 0 0 1 1.131.445L18.1 5.4a7.611 7.611 0 0 1 2.614 3.82h1.716v5.562H20.12a7.926 7.926 0 0 1-1.854 2.225 8.344 8.344 0 0 1-2.716 1.484"
  /><path d="M16.52 8.533a.348.348 0 0 1 0-.696M16.52 8.533a.348.348 0 1 0 0-.696" /><path
    stroke-linecap="round"
    stroke-linejoin="round"
    d="m17.525 17.525.733 2.819M7.133 15.94c3.072 0 5.562-1.245 5.562-2.781s-2.49-2.781-5.562-2.781-5.563 1.245-5.563 2.78c0 1.537 2.49 2.782 5.563 2.782Z"
  /><path
    stroke-linecap="round"
    stroke-linejoin="round"
    d="M1.57 13.159v6.49c0 1.538 2.494 2.78 5.563 2.78 3.068 0 5.562-1.242 5.562-2.78v-6.49"
  /><path
    stroke-linecap="round"
    stroke-linejoin="round"
    d="M12.695 16.404c0 1.539-2.494 2.78-5.562 2.78-3.069 0-5.563-1.241-5.563-2.78"
  /></g><defs><clipPath id="a"><path
    fill="none"
    d="M0 0h24v24H0z"
  /></clipPath></defs></svg>
</template>
